import World from './world';
import AssetLibrary from './asset-library';

export async function loadWorldLocal(worldName) {
  const url = `/worlds/${worldName}.json`;
  const res = await fetch(url);
  const json = await res.json();
  const world = World.fromJSON(json);
  return world;
}

export async function loadWorldRemote(worldName) {
  const url = `https://firestore.googleapis.com/v1/projects/enigmeta-parcitypate/databases/(default)/documents/worlds/${worldName}`;
  const res = await fetch(url);
  const doc = await res.json();
  const json = JSON.parse(doc.fields.json.stringValue);
  const world = World.fromJSON(json);
  return world;
}

export async function loadAssetLibraryLocal(assetLibraryName, onProgress) {
  const url = `/asset-libraries/${assetLibraryName}.json`;
  const res = await fetch(url);
  const json = await res.json();
  const assetLibrary = await AssetLibrary.fromJSON(json, true, onProgress);
  return assetLibrary;
}

export async function loadAssetLibraryRemote(assetLibraryName, onProgress) {
  const url = `https://firestore.googleapis.com/v1/projects/enigmeta-parcitypate/databases/(default)/documents/asset-libraries/${assetLibraryName}`;
  const res = await fetch(url);
  const doc = await res.json();
  const json = JSON.parse(doc.fields.json.stringValue);
  const assetLibrary = await AssetLibrary.fromJSON(json, false, onProgress);
  return assetLibrary;
}
